module.exports = __webpack_public_path__ + "static/img/FITmenu12.de20764.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FITmenu12.png
// module id = 9Nai
// module chunks = 1